<template>
    <footer id="footer" class="footer">
        <div class="copyright">
            &copy; Copyright <strong><span>Fastana Logistik Indonesia</span></strong>.
        </div>
    </footer>
</template>
<script>
export default {
  name: 'FooterComponent'
};
</script>